import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { GlobalProvider } from './providers/GlobalProvider';
import NotificationWrapper from 'components/Common/NotificationWrapper';

import 'resources/styles/index.css';
import 'resources/styles/MobileResponsive.css';
import 'resources/styles/TabResponsive.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';
import Hotjar from './Hotjar.jsx';

const muiLicense: string = process.env.REACT_APP_MUI_LICENSE!;

LicenseInfo.setLicenseKey(muiLicense);

window.addEventListener('unhandledrejection', (event) => {
  console.log(event.reason);
});

// const executionSchedule = '30 23 * * *';
// scheduleJob(executionSchedule, async() => {
//   let results = [];
//   let rowData = [];

//   // RETRIEVE THE PREVIOUS DAYS RESULTS FROM MONGODB
//   const res = await AutomationAPI.getAllAutomations();
//   if (res?.result.length > 0) {
//     const reports = res?.result;

//     for (const report of reports) {
//       // RETRIEVE THE DOCUMENT FROM AWS OR MONGO
//       const doc = await getDoc(report.bucketName);

//       // RUN THE DOCUMENT THROUGH BITE BULK TO GET THE RESULTS OF TODAY
//       const curr_results: any = await bulkReportCall(doc);

//       results = curr_results?.results;
//       rowData = curr_results?.props;

//       if (report.results.length) {
//         // COMPARE THE RESULTS AND UPDATE MONGODB IF NECCESSARY
//         await compareResults(results, report.results, report.userEmail);
//       }

//       // CREATE TICKET FOR THE DAILY REPORT
//       createTicket(results, rowData, report.userId);
//     };
//   };
// });

/* eslint-disable */
const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <NotificationWrapper>
      <GlobalProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BrowserRouter>
        <Hotjar />
          <App />
        </BrowserRouter>
        </LocalizationProvider>
      </GlobalProvider>
    </NotificationWrapper>,
  );
}
renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();